import { defineStore } from 'pinia'
import axios from 'axios'

export const useMilestonesStore = defineStore('milestones', {
  state: () => ({
    milestones: [],
    loading: false,
    error: null,
    selectedMilestone: null
  }),

  getters: {
    getMilestones: (state) => state.milestones,
    isLoading: (state) => state.loading,
    getError: (state) => state.error,
    getSelectedMilestone: (state) => state.selectedMilestone
  },

  actions: {
    async fetchMilestones(fixtureId) {
      this.loading = true
      this.error = null
      try {
        const response = await axios.get(`/api/milestones/${fixtureId}`)
        let rawData = null
        
        // Handle different response formats
        if (Array.isArray(response.data)) {
          rawData = response.data
        } else if (response.data && Array.isArray(response.data.data)) {
          rawData = response.data.data
        } else if (response.data && Array.isArray(response.data.milestones)) {
          rawData = response.data.milestones
        } else {
          // Fallback to empty array if format is unexpected
          console.warn('Unexpected response format for milestones:', response.data)
          this.milestones = []
          return
        }

        // Validate and set the data
        try {
          // Ensure all items are valid objects
          const validated = rawData.filter(item => item && typeof item === 'object')
          this.milestones = validated
        } catch (validationError) {
          console.error('Error validating milestone data:', validationError)
          // Fallback to raw data if validation fails
          this.milestones = rawData || []
        }
      } catch (error) {
        this.error = error.message || 'Failed to fetch milestones'
        console.error('Error fetching milestones:', error)
        this.milestones = [] // Reset to empty array on error
      } finally {
        this.loading = false
      }
    },

    setSelectedMilestone(milestone) {
      this.selectedMilestone = milestone
    },

    async createMilestone(milestoneData) {
      this.loading = true
      this.error = null
      try {
        const response = await axios.post('/api/milestones', milestoneData)
        this.milestones.push(response.data)
        return response.data
      } catch (error) {
        this.error = error.message || 'Failed to create milestone'
        throw error
      } finally {
        this.loading = false
      }
    },

    async updateMilestone(id, milestoneData) {
      this.loading = true
      this.error = null
      try {
        const response = await axios.put(`/api/milestones/${id}`, milestoneData)
        const index = this.milestones.findIndex(m => m.id === id)
        if (index !== -1) {
          this.milestones[index] = response.data
        }
        return response.data
      } catch (error) {
        this.error = error.message || 'Failed to update milestone'
        throw error
      } finally {
        this.loading = false
      }
    },


  }
})

